import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import _ from 'lodash';
import { auth0Config } from '../../../config';

let globalAccessToken = null;
let globalUserId = undefined;
let globalIsLoading = true;

export const useFetchAccessToken = () => {
  const { getAccessTokenSilently, isAuthenticated, isLoading, user } = useAuth0();
  const [loading, setLoading] = useState(true);
  const [accessToken, setAccessToken] = useState(true);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const fetchToken = async () => {
      if (isAuthenticated) {
        try {
          const token = await getAccessTokenSilently({
            authorizationParams: {
              audience: auth0Config.audience,
            },
          });
          globalAccessToken = token;
          setAccessToken(token);
        } catch (error) {
          console.log('Error getting access token:', error);
        }
      } else {
        setAccessToken(null);
        globalAccessToken = null;
      }
      setLoading(isLoading);
      globalIsLoading = isLoading;
    };

    fetchToken();
  }, [isAuthenticated, isLoading, getAccessTokenSilently]);

  useEffect(() => {
    if (isAuthenticated && user) {
      setUserId(user.sub);
      globalUserId = user.sub;
    } else {
      setUserId(null);
      globalUserId = null;
    }
  }, [user, isAuthenticated]);

  return { loading, accessToken, userId };
};

export const withAccessToken = (WrappedComponent) => {
  return (props) => {
    const { accessToken, userId } = useFetchAccessToken();

    // Pass the accessToken as a prop to the wrapped component
    return <WrappedComponent accessToken={accessToken} userId={userId} {...props} />;
  };
};

export const getAccessToken = async () => globalAccessToken;

export const getCurrentUserId = async () => globalUserId;

export const hasActiveSession = async () => {
  while (globalIsLoading) {
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
  return !!globalAccessToken;
};
